// src/views/contasBancarias/TransacaoModal.jsx
import React, { useState, useEffect } from "react";
import contasContabeisService from "../../services/contasContabeisService";

const EMPTY = {
  tpMovimento:"Credito", origem:"Manual", vlrTransacao:"",
  dtTransacao: new Date().toISOString().split("T")[0],
  dtCompetencia:"", historico:"", nrDocumento:"",
  nossoNumero:"", seuNumero:"", nrBancario:"",
  sacado:"", idContaContabil:"", observacao:"",
};

const ORIGENS = [
  "Manual","Boleto","Transferencia","PIX","TED","DOC","Cheque","DebitoAutomatico","Outro"
];

export default function TransacaoModal({ show, onClose, onSave, editData, saving=false, idCondominio, contaNome="" }) {
  const isEdit = !!editData?.id;
  const [form, setForm]           = useState(EMPTY);
  const [errors, setErrors]       = useState({});
  const [contasContabeis, setContasContabeis] = useState([]);

  useEffect(() => {
    if (!idCondominio) return;
    contasContabeisService.listar({ idCondominio, situacao:"ativo", natureza:"Analitica" })
      .then(r => setContasContabeis(r.data||[])).catch(()=>{});
  }, [idCondominio]);

  useEffect(() => {
    if (!show) return;
    const base = editData ? { ...EMPTY, ...editData } : { ...EMPTY };
    if (base.dtTransacao?.includes("T")) base.dtTransacao = base.dtTransacao.split("T")[0];
    if (base.dtCompetencia?.includes("T")) base.dtCompetencia = base.dtCompetencia.split("T")[0];
    setForm(base); setErrors({});
  }, [show, editData]);

  const set = (f,v) => { setForm(p=>({...p,[f]:v})); setErrors(p=>({...p,[f]:undefined})); };

  const validate = () => {
    const e={};
    if(!form.vlrTransacao || parseFloat(form.vlrTransacao)<=0) e.vlrTransacao="Valor deve ser maior que zero";
    if(!form.dtTransacao) e.dtTransacao="Data obrigatória";
    if(!form.historico?.trim()) e.historico="Histórico obrigatório";
    setErrors(e); return Object.keys(e).length===0;
  };

  if (!show) return null;

  return (
    <div className="modal fade show d-block" style={{background:"rgba(0,0,0,.55)"}} tabIndex="-1">
      <div className="modal-dialog modal-lg modal-dialog-scrollable">
        <div className="modal-content">
          <div className="modal-header">
            <div className="d-flex align-items-center gap-3">
              <div style={{width:38,height:38,background:"rgba(255,255,255,.15)",borderRadius:8,display:"flex",alignItems:"center",justifyContent:"center"}}>
                <i className="bi bi-arrow-left-right" style={{fontSize:18,color:"#fff"}}/>
              </div>
              <div>
                <h5 className="modal-title mb-0">{isEdit?"Editar Transação":"Nova Transação"}</h5>
                <small style={{color:"rgba(255,255,255,.6)",fontSize:12}}>{contaNome}</small>
              </div>
            </div>
            <button className="btn-close btn-close-white" onClick={onClose}/>
          </div>

          <div className="modal-body">
            <div className="form-section">
              <div className="form-section-title"><i className="bi bi-arrow-left-right"/> Movimento</div>
              <div className="row g-3">
                <div className="col-md-3">
                  <label className="form-label">Tipo</label>
                  <div className="d-flex gap-2">
                    {["Credito","Debito"].map(tp=>(
                      <button key={tp} type="button"
                        className={`btn flex-fill ${form.tpMovimento===tp?(tp==="Credito"?"btn-success":"btn-danger"):"btn-outline-secondary"}`}
                        style={{fontSize:13,fontWeight:600}}
                        onClick={()=>set("tpMovimento",tp)}>
                        <i className={`bi bi-arrow-${tp==="Credito"?"down":"up"}-circle me-1`}/>
                        {tp==="Credito"?"Crédito":"Débito"}
                      </button>
                    ))}
                  </div>
                </div>
                <div className="col-md-3">
                  <label className="form-label">Valor (R$) <span className="required-mark">*</span></label>
                  <div className="input-group">
                    <span className="input-group-text" style={{background:form.tpMovimento==="Credito"?"#DCFCE7":"#FEE2E2",color:form.tpMovimento==="Credito"?"#166534":"#991B1B",fontWeight:700}}>R$</span>
                    <input className={`form-control ${errors.vlrTransacao?"is-invalid":""}`} type="number" step="0.01" min="0.01" value={form.vlrTransacao} onChange={e=>set("vlrTransacao",e.target.value)}/>
                    {errors.vlrTransacao&&<div className="invalid-feedback">{errors.vlrTransacao}</div>}
                  </div>
                </div>
                <div className="col-md-3">
                  <label className="form-label">Data <span className="required-mark">*</span></label>
                  <input type="date" className={`form-control ${errors.dtTransacao?"is-invalid":""}`} value={form.dtTransacao} onChange={e=>set("dtTransacao",e.target.value)}/>
                  {errors.dtTransacao&&<div className="invalid-feedback">{errors.dtTransacao}</div>}
                </div>
                <div className="col-md-3">
                  <label className="form-label">Data de Competência</label>
                  <input type="date" className="form-control" value={form.dtCompetencia} onChange={e=>set("dtCompetencia",e.target.value)}/>
                </div>
                <div className="col-md-4">
                  <label className="form-label">Origem</label>
                  <select className="form-select" value={form.origem} onChange={e=>set("origem",e.target.value)}>
                    {ORIGENS.map(o=><option key={o} value={o}>{o.replace(/([A-Z])/g," $1").trim()}</option>)}
                  </select>
                </div>
                <div className="col-md-8">
                  <label className="form-label">Histórico <span className="required-mark">*</span></label>
                  <input className={`form-control ${errors.historico?"is-invalid":""}`} value={form.historico} onChange={e=>set("historico",e.target.value)} placeholder="Descrição do lançamento"/>
                  {errors.historico&&<div className="invalid-feedback">{errors.historico}</div>}
                </div>
              </div>
            </div>

            <div className="form-section">
              <div className="form-section-title"><i className="bi bi-file-text"/> Identificação</div>
              <div className="row g-3">
                <div className="col-md-4">
                  <label className="form-label">Nº do Documento</label>
                  <input className="form-control" value={form.nrDocumento} onChange={e=>set("nrDocumento",e.target.value)} placeholder="Nº do documento"/>
                </div>
                <div className="col-md-4">
                  <label className="form-label">Nosso Número</label>
                  <input className="form-control" value={form.nossoNumero} onChange={e=>set("nossoNumero",e.target.value)}/>
                </div>
                <div className="col-md-4">
                  <label className="form-label">Seu Número</label>
                  <input className="form-control" value={form.seuNumero} onChange={e=>set("seuNumero",e.target.value)}/>
                </div>
                <div className="col-md-4">
                  <label className="form-label">Nº Bancário</label>
                  <input className="form-control" value={form.nrBancario} onChange={e=>set("nrBancario",e.target.value)}/>
                </div>
                <div className="col-md-4">
                  <label className="form-label">{form.tpMovimento==="Credito"?"Pagador":"Beneficiário"}</label>
                  <input className="form-control" value={form.sacado} onChange={e=>set("sacado",e.target.value)} placeholder="Nome do pagador/beneficiário"/>
                </div>
                <div className="col-md-4">
                  <label className="form-label">Conta Contábil</label>
                  <select className="form-select" value={form.idContaContabil} onChange={e=>set("idContaContabil",e.target.value)}>
                    <option value="">— Sem vínculo —</option>
                    {contasContabeis.map(c=><option key={c.id} value={c.id}>{c.classificacaoContabil} — {c.descConta}</option>)}
                  </select>
                </div>
                <div className="col-12">
                  <label className="form-label">Observações</label>
                  <textarea className="form-control" rows={2} value={form.observacao} onChange={e=>set("observacao",e.target.value)}/>
                </div>
              </div>
            </div>
          </div>

          <div className="modal-footer d-flex justify-content-between">
            <div style={{fontSize:12,color:"var(--gray-400)"}}><i className="bi bi-asterisk me-1" style={{color:"#ef4444",fontSize:9}}/>Campos obrigatórios</div>
            <div className="d-flex gap-2">
              <button className="btn btn-outline-secondary" onClick={onClose}><i className="bi bi-x-circle"/> Cancelar</button>
              <button className="btn btn-primary" onClick={()=>{ if(validate()) onSave({...form,id:editData?.id}); }} disabled={saving}>
                {saving?<><span className="spinner-border spinner-border-sm me-2"/>Salvando...</>:<><i className="bi bi-check-circle"/> {isEdit?"Salvar":"Registrar"}</>}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
